module.exports = __webpack_public_path__ + "img/report3.1af830c2.svg";